"use client"
/**
 * Common (All) Requirements Page
 * Route: /requirements/common
 * Shows the Projects table; clicking Requirements opens a drawer
 * that shows ONLY the "Common (All)" requirements.
 */
import React, { useState } from 'react'
import { FaUsers } from 'react-icons/fa'
import { useAuth } from '../../provider/auth.provider'
import { ProjectManagement } from '../projects'
import { ProjectRequirementsDrawer } from './drawer'

interface Project {
  id: number
  project_name: string
  project_short_name: string
  activity_id: number
  activity?: { id: number; activity_name: string }
}

const CommonRequirementsPage: React.FC = () => {
  const { user } = useAuth()
  const [drawerOpen, setDrawerOpen]       = useState(false)
  const [selectedProject, setSelectedProject] = useState<Project | null>(null)

  return (
    <div>

      {/* Projects table — show only projects assigned to current user (unless admin) */}
      <ProjectManagement
        onRequirementsClick={(project) => {
          setSelectedProject(project as Project)
          setDrawerOpen(true)
        }}
        hideAddProjectButton={true}
        filterByCurrentUser={user?.role.level !== 1} // Only non-admin users see their assigned projects
      />

      {/* Drawer — common tab only */}
      <ProjectRequirementsDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        project={selectedProject}
        allowedType="common"
      />
    </div>
  )
}

export default CommonRequirementsPage

